import { SUB_PAGES } from "../../../../interfaces/RegionalPage";
import { MIDDLE_EAST_EARLY_CAREERS } from "./_early_careers";
import { MIDDLE_EAST_EXPERIENCED_HIRES } from "./_experienced_hires";

export const MIDDLE_EAST_SUB_PAGES: SUB_PAGES[] = [
    MIDDLE_EAST_EXPERIENCED_HIRES,
    MIDDLE_EAST_EARLY_CAREERS
]